import * as yup from "yup";

export const ProductAndDiscountValidationSchema =
  yup.object().shape({
    startDate: yup
      .date()
      .typeError('O valor do início da vigência precisa ser uma data válida.')
      .test('max', 'a data inicial não pode ser superior à final', (value, obj) => {
        const endDate = obj.parent.endDate
        const isendDateFilled = endDate.toString() !== 'Invalid Date'
        if (value && isendDateFilled) {
          return value < endDate
        } else if (value && !isendDateFilled) {
          return true
        }
        return false
      })
      .required("é um campo obrigatório"),
    endDate: yup
      .date()
      .typeError('O valor do fim da vigência precisa ser uma data válida.')
      .test('min', 'a data final não pode ser inferior à inicial', (value, obj) => {
        const startDate = obj.parent.startDate
        const isstartDateFilled = startDate.toString() !== 'Invalid Date'
        if (value && isstartDateFilled) {
          return value > startDate
        } else if (value && !isstartDateFilled) {
          return true
        }
        return false
      })
      .test('min', 'a data e hora final da vigência não pode ser inferior a data e hora atual', (value) => {
        const actualDate = new Date()
        if (value && value > actualDate) {
          return true
        } else {
          return false
        }
      })
      .required("é um campo obrigatório"),
    product: yup
      .array()
      .required()
      .of(
        yup
          .string()
          .required("É necessário selecionar um produto para continuar.")
      )
      .min(1, "É necessário selecionar um produto para continuar."),
    formulaAttributes: yup
      .mixed()
      .test('isValid', 'É necessário selecionar alguma das fórmulas de cálculo de ressarcimento disponíveis para continuar.', (value, obj) => {
        const validFormulas = ['["INDUSTRY_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]',
          '["UNIT_PRICE","MULTIPLICATION","DISCOUNT","MULTIPLICATION","SALE_QUANTITY"]']
        if (Array.isArray(value)) {
          value = JSON.stringify(value)
        }
        return validFormulas.includes(value)
      }),
    ranges: yup
      .array()
      .of(
        yup.object().shape({
          discount: yup
            .number()
            .typeError('O valor do desconto do paciente deve ser um número entre 0% e 100%')
            .required("obrigatório")
            .min(0, "O valor do desconto do paciente deve estar entre 0% e 100%")
            .max(100, "O valor do desconto do paciente deve estar entre 0% e 100%"),
          discountRefund: yup
            .number()
            .typeError('O valor do desconto fixo deve ser um número entre 0% e 100%')
            .required("obrigatório")
            .min(0, "O valor do desconto fixo deve estar entre 0% e 100%")
            .max(100, "O valor do desconto fixo deve estar entre 0% e 100%"),
        })
      )
      .test('dontRepeated', 'não podem haver valores de desconto do paciente repetidos', (value, obj) => {
        const discount = value?.map(range => range.discount) || [];
        return (new Set(discount)).size === discount?.length
      })
      .min(1, "deve conter pelo menos uma faixa de desconto"),
  });
